module.exports = __webpack_public_path__ + "media/images/home-hero-dcb4acd7e39887d2d0b777d575cb92d0.png";